import { render, staticRenderFns } from "./NoAccessMessage.vue?vue&type=template&id=0e2b127c&scoped=true"
import script from "./NoAccessMessage.vue?vue&type=script&lang=ts"
export * from "./NoAccessMessage.vue?vue&type=script&lang=ts"
import style0 from "./NoAccessMessage.vue?vue&type=style&index=0&id=0e2b127c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2b127c",
  null
  
)

export default component.exports